<template>
  <div class="el-col-24">
    <h5 class="warp-title">评价详情</h5>
    <div class="search">
      <div class="clearfix">
        <div class="search-type">
          <!-- <span class="search-title">工单ID</span> -->
          <el-input size="small" v-model.trim="userName" placeholder="请输入用户ID"></el-input>
        </div>
        <div class="search-type">
          <el-radio-group v-model="specifiedTime" size="small" @change="changeDate">
            <el-radio-button :label="1">30天</el-radio-button>
            <el-radio-button :label="2">近7天</el-radio-button>
            <el-radio-button :label="3">今天</el-radio-button>
          </el-radio-group>
        </div>
        <div class="search-type">
          <span class="search-title">统计时间</span>
          <el-date-picker
            @change="changeTime"
            v-model="time"
            size="small"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="dateShortCutOptions"
            >
          </el-date-picker>
        </div>
        <div class="search-type">
          <span class="search-title">是否满意</span>
          <el-select class="w100" v-model="areYouSatisfied" size="small" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="满意" :value="1"></el-option>
            <el-option label="不满意" :value="2"></el-option>
          </el-select>
        </div>
        <div class="search-type">
          <el-button size="small" type="primary" @click="search()" :loading="isSearchLoading">查询</el-button>
        </div>
        <div class="search-type">
          <el-button size="small" @click="export1()" :loading="isExportLoading">导出</el-button>
        </div>
      </div>
    </div>
    <div class="work-name">
      客服名称：{{name}} &nbsp;&nbsp;&nbsp; 客服账号：{{num}}
    </div>
    <el-table
      :data="tableData"
      border
      align="center"
      style="width: 100%">
      <el-table-column
        label="日期"
        align="center">
        <template slot-scope="scope">
          {{scope.row.evaluateDate}}
        </template>
      </el-table-column>
      <el-table-column
        label="用户ID"
        align="center">
        <template slot-scope="scope">
          {{ scope.row.userId }}
        </template>
      </el-table-column>
      <el-table-column
        label="满意度"
        align="center"
        width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.areYouSatisfied === 1">满意</span>
          <span v-if="scope.row.areYouSatisfied === 2">不满意</span>
        </template>
      </el-table-column>
      <el-table-column
        label="评价备注"
        align="center">
        <template slot-scope="scope">
          {{scope.row.evaluateContent}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="140">
        <template slot-scope="scope">
          <span class="blue cursor" @click="detail(scope.row)">查看详情</span>
          <span class="blue cursor" @click="openRecord(scope.row)">聊天记录</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt20"
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      align='right'
      background>
    </el-pagination>
    <el-dialog
      title="聊天记录查询"
      :visible.sync="showRecord"
      :close-on-click-modal="false"
      width="60%" top="3vh">
      <div class="chat-search">
        <el-input size="small" v-model.trim="searchForm.body" placeholder="关键字/用户手机号"></el-input>
        <el-date-picker
          v-model="recordTime"
          size="small"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="dateShortCutOptions">
        </el-date-picker>
        <el-button size="small" type="primary" @click="onSearchRecord" :loading="isRecordLoading">查询</el-button>
      </div>
      <MessageList :list="recordData" :currentUserId="searchForm.customerUserId" />
      <div v-if="recordData.length===0" class="no-record">暂无聊天记录</div>
      <el-pagination
        @size-change="sizeChange2"
        @current-change="currentChange2"
        :current-page="searchForm.currentPage"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        class="mt20"
        align="right"
        background>
      </el-pagination>
    </el-dialog>
    <el-dialog
      title="查看详情"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="evaluation"
      width="320px" top="5vh">
      <div>为了更好的帮助您，请对我们的服务进行评价请问 <span class="blue">客服 {{accName}}</span>  是否解决了您的问题？</div>
      <ul>
        <li>
          <img src="../../common/img/evaluation_icon5.png" alt="" srcset="" v-if="evaIcon !== 1">
          <img src="../../common/img/evaluation_icon6.png" alt="" srcset="" v-if="evaIcon === 1">
          <p>非常满意</p>
        </li>
        <li>
          <img src="../../common/img/evaluation_icon1.png" alt="" srcset="" v-if="evaIcon !== 2">
          <img src="../../common/img/evaluation_icon2.png" alt="" srcset="" v-if="evaIcon === 2">
          <p>不满意</p>
        </li>
      </ul>
      <p class="evaline">
        <span v-if="evaIcon === 1">夸夸客服（可多选）</span>
        <span v-if="evaIcon === 2">有哪些不足（可多选）</span>
      </p>
      <div class="evatype">
        <div v-for="(item, index) in eveTypeList" :key="index" v-if="item.ela === evaIcon">
          <input type="checkbox" :id="'eveType' + item.id" :value="item.id" v-model="eveTypeUl" disabled>
          <label :for="'eveType' + item.id">
            {{item.name}}
          </label>
        </div>
      </div>
      <div class="eva-remark">
        {{remark}}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dateShortCutOptions from '../../utils/dateShortCutOptions'
import formatDateByTimestamp from '../../utils/formatDateByTimestamp'
import {queryUserEvaluatelList, exportUserEvaluatelList, queryChatHistoryRecord} from '../../api/statistics/index'
// import { queryButtonPermission } from '../../api/public/auth'
export default {
  name: 'WorkDetail',
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
    // let data = {
    //   id: global.$sider
    // }
    // queryButtonPermission(data).then((info) => {
    //   if (info.data.resultCode === 0) {
    //     this.querybtn = info.data.resultData
    //   } else {
    //     this.$message.error(info.data.resultMessage)
    //   }
    // })
  },
  watch: {
    recordTime () {
      if (this.recordTime && this.recordTime.length > 0) {
        this.searchForm.startTime = this.recordTime[0]
        this.searchForm.endTime = this.recordTime[1]
      }
    }
  },
  data () {
    return {
      isRecordLoading: false,
      dateShortCutOptions: dateShortCutOptions,
      isExportLoading: false,
      isSearchLoading: false,
      id: this.$route.params.id,
      num: this.$route.query.num,
      name: this.$route.query.name,
      // querybtn: {},
      userName: '',
      specifiedTime: this.$route.query.time,
      areYouSatisfied: '',
      loading: '',
      time: this.$route.query.day,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      showRecord: false,
      searchForm: {
        body: '',
        startTime: '',
        endTime: '',
        customerAccId: '',
        userId: '',
        currentPage: 1,
        pageSize: 100
      },
      userTypeOption: [],
      tableData: [],
      totalCount: 0,
      recordData: [],
      recordTime: [],
      accName: '',
      evaIcon: 1,
      remark: '',
      eveTypeList: [{
        ela: 1,
        name: '服务态度好',
        id: 1
      }, {
        ela: 1,
        name: '回复及时',
        id: 2
      }, {
        ela: 1,
        name: '回答专业程度高',
        id: 3
      }, {
        ela: 2,
        name: '态度不好',
        id: 4
      }, {
        ela: 2,
        name: '回复不及时',
        id: 5
      }, {
        ela: 2,
        name: '回答不专业',
        id: 6
      }, {
        ela: 2,
        name: '其他问题',
        id: 7
      }],
      eveTypeUl: []
    }
  },
  methods: {
    initdata () {
      let startTime = ''
      let endTime = ''
      if (this.time && this.time.length > 0) {
        startTime = this.time[0]
        endTime = this.time[1]
      }
      let data = {
        startTime: startTime,
        endTime: endTime,
        customerId: this.id,
        userName: this.userName,
        specifiedTime: this.specifiedTime,
        areYouSatisfied: this.areYouSatisfied,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      this.isSearchLoading = true
      queryUserEvaluatelList(data).then(info => {
        this.initChatRecordTime()
        this.isSearchLoading = false
        let data = info.data
        if (info.data.resultCode === 0) {
          this.total = data.totalCount
          this.tableData = data.resultData
          let pageNum = Math.ceil(info.data.totalCount / this.pageSize)
          if (pageNum !== 0 && this.currentPage > pageNum) {
            this.currentPage = pageNum
            this.initdata()
          }
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isSearchLoading = false
      })
    },
    currentChange (val) {
      this.currentPage = val
      this.initdata()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.initdata()
    },
    search () {
      this.initdata()
    },
    changeTime () {
      if (!this.time) {
        this.specifiedTime = 3
      } else {
        this.specifiedTime = ''
      }
    },
    changeDate () {
      this.time = []
    },
    detail (item) {
      this.evaIcon = item.areYouSatisfied
      this.remark = item.evaluateContent
      this.accName = item.customerName
      // console.log(item.evaluationLabel)
      let list = JSON.parse(item.evaluationLabel)
      if (list) {
        this.eveTypeUl = list
      } else {
        this.eveTypeUl = []
      }
      this.dialogVisible = true
    },
    // 初始化聊天记录筛选的时间（默认一年范围）
    initChatRecordTime () {
      if (this.time && this.time.length > 0) {
        this.recordTime = [...this.time]
      } else {
        // 天数跨度
        let dayStep = this.specifiedTime === 1 ? 30 : this.specifiedTime === 2 ? 7 : 0
        let start = formatDateByTimestamp(Date.now() - (1000 * 60 * 60 * 24 * dayStep))
        let end = formatDateByTimestamp(Date.now())
        this.recordTime = [start, end]
      }
    },
    // 打开聊天记录弹框
    openRecord (item) {
      this.searchForm.customerUserId = item.customerUserId
      this.searchForm.userId = item.userId
      this.searchForm.endTime = item.evaluateDate
      this.searchForm.body = ''
      this.searchForm.currentPage = 1
      this.searchForm.pageSize = 100
      this.recordData = []
      this.totalCount = 0
      // this.initChatRecordTime()
      this.showRecord = true
      this.initRecordList()
    },
    // 查询聊天记录
    onSearchRecord () {
      this.searchForm.currentPage = 1
      this.initRecordList()
    },
    // 初始化聊天记录数据
    initRecordList () {
      this.isRecordLoading = true
      queryChatHistoryRecord(this.searchForm).then(res => {
        if (res.data.resultCode === 0) {
          this.recordData = res.data.resultData
          this.totalCount = res.data.totalCount
        } else {
          this.$message.error(res.data.resultMessage)
        }
      }).catch(() => {
        this.$message.error('出错了~')
      }).finally(() => {
        this.isRecordLoading = false
      })
    },
    currentChange2 (current) {
      this.searchForm.currentPage = current
      this.initRecordList()
    },
    sizeChange2 (size) {
      this.searchForm.pageSize = size
      this.searchForm.currentPage = 1
      this.initRecordList()
    },
    export1 () {
      let startTime = ''
      let endTime = ''
      if (this.time) {
        startTime = this.time[0]
        endTime = this.time[1]
      }
      let data = {
        customerId: this.id,
        userName: this.userName,
        specifiedTime: this.specifiedTime,
        areYouSatisfied: this.areYouSatisfied,
        startTime: startTime,
        endTime: endTime
      }
      this.isExportLoading = true
      exportUserEvaluatelList(data).then(info => {
        this.isExportLoading = false
        if (info.data.resultCode === 0) {
          let Url = info.data.resultData.fileDownLoadUrl
          window.open(Url)
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isExportLoading = false
      })
    }
  },
  mounted () {
    this.initdata()
  }
}
</script>
<style lang="less" scoped>
.search{
  a{
    line-height: 32px;
  }
}
.el-tabs{
  margin-top: 20px;
}
.el-button + .el-button{
  margin-left: 0;
}
.chat-search{
  display: table;
  margin-bottom: 20px;
  .el-input{
    width: 150px;
    margin-right: 10px;
    float: left;
  }
  .el-date-editor{
    width: 250px;
    float: left;
    margin-right: 10px;
  }
  .el-button{
    float: left;
  }
}
.evaluation{
  font-size: 14px;
  color: #666666;
  line-height: 20px;
}
.evaluation ul{
  margin-top: 20px;
  height: 56px;
  margin-bottom: 16px;
  text-align: center;
}
.evaluation li {
  /* float: left; */
  width: 50px;
  margin: 0 21px;
  text-align: center;
  font-size: 12px;
  color: #999999;
  display: inline-block;
}
.evaluation li img{
  width: 32px;
}
.evaluation li p{
  margin-top: 6px;
  line-height: 18px;
}
.eva-remark{
  border-radius: 4px;
  border: 1px solid #E8E8E8;
  box-sizing: border-box;
  padding: 10px;
  height: 110px;
  overflow-y: auto;
}
.eva-remark p{
  color: #CCCCCC;
  font-size: 12px;
  text-align: right;
  line-height: 20px;
}
.evaline span{
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  padding: 0 14px;
  background: #FFFFFF;
  display: inline-block;
  position: relative;
}
.evaline{
  position: relative;
  text-align: center;
  margin-bottom: 14px;
}
.evaline::before{
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background: #F1F2F4;
  position: absolute;
  top: 8px;
  z-index: 0;
}
.evatype{
  display: table;
}
.evatype>div{
  float: left;
  width: 130px;
  height: 32px;
  margin-bottom: 10px;
}
.evatype label{
  width: 130px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid #E8E8E8;
  color: #333333;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  display: block;
}
.evatype>div:nth-of-type(odd) {
  margin-right: 20px;
}
.evatype input{
  display: none;
}
.evatype input[type='checkbox']:checked~label{
  background: url(../../common/img/sub.png) no-repeat bottom right;
  background-size: 18px 18px;
  border: 1px solid #0087FF;
  color: #0087FF;
}
.work-name{
  font-size: 16px;
  margin-bottom: 30px;
  font-weight: 500;
}
.no-record{
  text-align: center;
  margin-top: 40px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics/WorkDetail.vue